module.exports = __webpack_public_path__ + "4eaadda92420988d23e9d133b4096eb3.png";